module.exports = __webpack_public_path__ + "img/default_boy.90999036.png";